export default {
    data() {
        return {
            errors: null,
            status: null,
        }
    },
    computed: {
        hasErrors() {
            return (422 === this.status || 409 === this.status || 401 === this.status || 400 === this.status) && this.errors !== null;
        },
    },
    methods: {
        errorsFor(field) {
            return this.hasErrors && this.errors[field] ? this.errors[field] : null;
        }
    },
}
